import {
  type Load,
  getRatePerMile,
  getListOfCommodities,
  hasItemCommodity,
  hasMileage,
} from '../domain/Load'
import { formatCurrency } from '../utils/currency'
import { parseNumber } from '../utils/number'

export function getCommodities(load: Load): string {
  if (hasItemCommodity(load)) {
    return getListOfCommodities(load).join(', ')
  }

  return ''
}

export function getFormattedRate(load: Load): string {
  return formatCurrency(parseNumber(load.flatRate))
}

export function getFormattedRatePerMile(load: Load) {
  return hasMileage(load) ? formatCurrency(getRatePerMile(load), true) : undefined
}
